import React from "react";
import { cn } from "utils";
import { Icon } from "@ospweb/sdk-ui";
import Translations from "@translate/components/Portfolio/Search/SearchTrigger";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

interface SearchTriggerProps {
  onClick: () => void;
  expanded?: boolean; // 外部控制的展开（active 态时强制展开）
}

/**
 * SearchTrigger
 * - 桌面端搜索触发组件
 * - 实现 hover 展开动画：图标左移 + 文案渐显
 * - 支持外部控制的 hover 状态
 */
export const SearchTrigger: React.FC<SearchTriggerProps> = ({
  onClick,
  expanded = false,
}) => (
  <div
    data-openreplay-label="Search · SearchTrigger · div"
    className="group hidden md:flex items-center justify-end h-9 overflow-hidden cursor-pointer select-none"
    data-testid="portfolio-tab-search-trigger"
    onClick={onClick}
    role="button"
    tabIndex={0}
  >
    {/* 外层宽度：初始 16px（w-4），hover 或 expanded 展开到 200px */}
    <div
      className={cn(
        "flex items-center justify-end transition-[width] duration-200 ease-out w-4 group-hover:w-[200px]",
        expanded && "w-[200px]",
      )}
    >
      {/* 搜索图标 16x16，hover 左移 8px */}
      <div
        className={cn(
          "w-4 h-4 flex items-center justify-center transition-transform duration-200 ease-out",
          expanded ? "-translate-x-1" : "translate-x-0",
          "group-hover:-translate-x-1",
        )}
      >
        <Icon name="search" size={16} className="text-content_tertiary" />
      </div>
      {/* 文案：初始不占位，hover 时占位并渐显 */}
      <div
        className={cn(
          "overflow-hidden transition-[max-width] duration-200 ease-out h-4 flex items-center max-w-0 group-hover:max-w-[160px]",
          expanded && "max-w-[160px]",
        )}
      >
        <span
          className={cn(
            "ml-1 button_m text-content_tertiary whitespace-nowrap transition-opacity duration-200 ease-out leading-4 opacity-0 group-hover:opacity-100",
            expanded && "opacity-100",
          )}
        >
          {I18n.t("Search your watchlist")}
        </span>
      </div>
    </div>
  </div>
);
